import {
    GET_HOME_RESOURCES_REQUEST,
    GET_HOME_RESOURCES_SUCCESS,
    GET_HOME_RESOURCES_FAILURE
} from '../actions';


const initialState = {};

const ResourcesReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_HOME_RESOURCES_REQUEST:
            return Object.assign({},state, {asyncStatus:  'PENDING'});
        case GET_HOME_RESOURCES_SUCCESS:
            return Object.assign({},state, {asyncStatus:  'SUCCESS', data: action.payload});
        case GET_HOME_RESOURCES_FAILURE:
            return Object.assign({},state, {asyncStatus:  'FAILURE', data: action.payload});
        default:
            return state;
    }
};

export default ResourcesReducer;